"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useConditionalCardStyles = () => {
    const theme = (0, material_1.useTheme)();
    const title = {
        fontFamily: 'inherit',
        color: theme.qlub.palette.onSurfaceColors.mediumEmphasis,
        fontSize: '0.875rem',
    };
    const leftToPay = {
        fontFamily: 'inherit',
        color: theme.qlub.palette.onSurfaceColors.mediumEmphasis,
        fontSize: '0.875rem !important',
    };
    const card = {
        padding: `${theme.spacing(3)}`,
        borderRadius: '8px',
        boxShadow: 'none',
        margin: `${theme.spacing(2)} ${theme.spacing(3)}`,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
        position: 'relative',
        '&.success': {
            backgroundColor: theme.qlub.palette.success.transparent,
        },
        '&.error ': {
            backgroundColor: theme.qlub.palette.danger.transparent,
        },
        '&.partial': {
            backgroundColor: theme.qlub.palette.partial.transparent,
        },
        '&.pending': {
            backgroundColor: theme.qlub.palette.pending.transparent,
        },
    };
    const cardHeader = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontFamily: 'inherit',
    };
    const body = {
        display: 'flex',
        justifyContent: 'space-between',
        pt: 0.5,
        '& p': {
            fontWeight: 500,
            fontSize: '1rem',
            fontFamily: 'inherit',
        },
    };
    const footer = {
        fontFamily: 'inherit',
        fontSize: '0.875rem',
        fontWeight: 400,
        color: theme.qlub.palette.onSurfaceColors.mediumEmphasis,
    };
    const queueNumber = {
        textAlign: 'center',
        fontSize: '23px',
    };
    const loyaltyBox = {
        display: 'flex',
        justifyContent: 'space-between',
        py: 1,
        '& div': {
            '& svg': {
                color: theme.qlub.palette.success.main,
                mr: 0.5,
                width: 18,
                height: 18,
            },
            display: 'flex',
            alignItems: 'center',
            '&:first-of-type': {
                '& span': {
                    '&:last-of-type': {
                        color: '#222222',
                    },
                },
            },
        },
    };
    const firstTitle = {
        '& span': {
            '&:first-of-type': {
                color: theme.qlub.palette.onSurfaceColors.mediumEmphasis,
            },
        },
    };
    const metaData = {
        marginTop: '12px',
        '& > div': {
            display: 'flex',
            justifyContent: 'space-between',
            '& p:first-of-type': {
                color: theme.qlub.palette.onSurfaceColors.mediumEmphasis,
            },
            '& p:nth-of-type(2)': {
                color: theme.qlub.palette.onSurfaceColors.highEmphasis,
            },
        },
        marginBottom: '-8px !important',
    };
    const divider = {
        position: 'absolute',
        marginLeft: `-24px !important`,
        marginRight: '-24px !important',
    };
    const transactionTime = {
        background: theme.qlub.palette.onColorColors.mediumEmphasis,
        width: '100%',
        borderRadius: '100px',
    };
    const transactionTimeContainer = {
        marginTop: '12px',
        textAlign: 'center',
        '& > div:nth-of-type(2), & > div:nth-of-type(2) > div': {
            marginTop: '12px',
        },
    };
    const corporateDiscountContainer = {
        color: theme.qlub.palette.success.main,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        pt: '6px',
        '& svg': {
            width: '15px !important',
            height: '15px !important',
            mr: '6px',
            'html[dir="rtl"] &': {
                mr: '0px',
                ml: '6px',
            },
        },
    };
    const corporateDiscount = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    };
    return {
        title,
        card,
        cardHeader,
        body,
        footer,
        leftToPay,
        queueNumber,
        loyaltyBox,
        firstTitle,
        metaData,
        divider,
        transactionTimeContainer,
        transactionTime,
        corporateDiscountContainer,
        corporateDiscount,
    };
};
exports.default = useConditionalCardStyles;
